// extracted by mini-css-extract-plugin
export default {"page":"DashboardLayout_page__6GM7C"};